module.exports = __webpack_public_path__ + "img/业务介绍.c84b980a.jpg";